
const prod = {
    API_URL: "https://api.tradevu.co",
    
};

const dev = {
    API_URL: "https://sandbox.tradevu.co",
   
};

const config = process.env.REACT_APP_STAGE === "production" ? prod : dev;

export default config;
